import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StringFormatPipe } from '../../pipe/string.format.pipe';
import { lastValueFrom } from '../../helpers/functions.helpers';

/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase CopyService, se utiliza para colocar información adicional al componente
 *
 * *Copy Service class definition, it's used to put aditional information in the component*
 *
 * @type {class}
 */
export class CopyService {

  /**
   * Definición de la variable copies como any
   *
   * *Copy Service variable definition as any*
   *
   * @type {any}
   */
  private _copies: any;
  public resource: any;

  private stringFormat =  new StringFormatPipe();

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @var {HttpClient} _http
   * @var {StringFormatPipe} stringFormat
   */
  constructor(
    private _http: HttpClient
  ) { }

  /**
   * Función para cargar las copias que están guardadas en ./assets/resources/copies.json
   *
   * *Function to load copies saved in ./assets/resources/copies.json*
   *
   * @type {function}
   * @param {string} customURL
   */
  async loadCopies(customURL?: string) {
    let url;

    if (!customURL) {
      url = './assets/resources/copies.json';
    } else {
      url = customURL;
    }

    /** 
     * @see https://rxjs.dev/deprecations/to-promise 
     */
    const req$ = this._http.get<any>(url);
    const response = await lastValueFrom(req$);

    if(response && response.hasOwnProperty('data') && response.data.hasOwnProperty('copies')){
      this.copies = response.data.copies;
    }else{
      this.copies = response;
    }
    return this.copies;
  }

  /**
   * Permite la carga de recursos adicionales
   * @param customURL 
   * @param customName 
   */
  async loadResouces(customURL?: string, customName?: string) {
    let url;
    if (!customURL) {
      url = './assets/resources/copies.json';
    } else {
      url = customURL;
    }

    /** 
     * @see https://rxjs.dev/deprecations/to-promise 
     */
    const req$ = this._http.get<any>(url);
    const response = await lastValueFrom(req$);
    if (customName && response.hasOwnProperty(customName)) {
      this.resource = response[customName];
    } else {
      this.resource = response;
    }
    return this.resource;
  }


  /**
   * Función para obtener las copias que están guardadas en ./assets/resources/copies.json
   *
   * *Function to obtain copies saved in ./assets/resources/copies.json*
   *
   * @type {function}
   * @param {string} copyName
   * @returns {string}
   */
  async getCopy(copyName: string, defaultValue?: {}) {
    const copies = await this.copies;
    if (copies && copies.hasOwnProperty(copyName)) {
      return copies[copyName];
    } else {
      return defaultValue;
    }
  }

  /**
   * Función para obtener las copias parametrizadas que están guardadas en ./assets/resources/copies.json
   *
   * *Function to obtain parametrized copies saved in ./assets/resources/copies.json*
   *
   * @type {function}
   * @param {string} copyName
   * @returns {string}
   */
  async getParametrizedCopy(copyName: string, parameters: string[], fatherCopyName?: string): Promise<string> {
    const copies = await this.copies;
    const copy = fatherCopyName ? copies[fatherCopyName][copyName] : copies[copyName];
    return this.stringFormat.transform(copy, parameters);
  }

  /**
   * Permite establecer los datos relacionados con los copies (textos estaticos)
   */
  set copies(value: any) {
    this._copies = value;
  }

  /**
   * Permite verificar y obtener los datos relacionados con los copies (textos estaticos)
   */
  get copies(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!this._copies) {
        await this.loadCopies();
      }
      resolve(this._copies);
    });
  }

}
